import React from 'react';
import { Typography } from 'lib/cortiUI';
export const ViewTitle = ({ title }) => {
    return (React.createElement(Typography, { variant: "h6", color: "default", "data-cy": "performance-view-title" }, title));
};
